import api from './api';

// 통계 조회
export const getStats = async () => {
  const response = await api.get('/stats');
  return response.data;
};
